import { jsPDF } from "jspdf";

const money = (n) => `Rs. ${Number(n || 0).toLocaleString("en-IN", { minimumFractionDigits: 2 })}`;
const fwName = (f) => (f === "indas" ? "Ind AS" : "Indian GAAP (AS)");

export const entryToText = (lines = []) =>
  lines
    .map((l) => `${l.type === "debit" ? "Dr" : "Cr"}  ${l.account}  ${money(l.amount)}`)
    .join("\n");

export const downloadAnalysisPdf = (r) => {
  const doc = new jsPDF({ unit: "pt", format: "a4" });
  const M = 48;
  const W = doc.internal.pageSize.getWidth() - M * 2;
  let y = M;

  const page = () => {
    if (y > doc.internal.pageSize.getHeight() - 70) {
      doc.addPage();
      y = M;
    }
  };
  const heading = (t) => {
    page();
    y += 14;
    doc.setFont("helvetica", "bold").setFontSize(10).setTextColor(80);
    doc.text(t.toUpperCase(), M, y);
    y += 6;
    doc.setDrawColor(200).line(M, y, M + W, y);
    y += 14;
  };
  const body = (t) => {
    doc.setFont("helvetica", "normal").setFontSize(10).setTextColor(30);
    doc.splitTextToSize(String(t), W).forEach((ln) => {
      page();
      doc.text(ln, M, y);
      y += 14;
    });
  };

  doc.setFont("times", "bold").setFontSize(22).setTextColor(15, 23, 42);
  doc.text("LedgerCheck — Entry Review", M, y);
  y += 22;
  doc.setFont("helvetica", "normal").setFontSize(9).setTextColor(120);
  doc.text(
    `${fwName(r.framework)}  ·  confidence ${r.confidence}  ·  ${new Date(r.created_at).toLocaleString("en-IN")}`,
    M,
    y
  );
  y += 26;

  const verdictText = { correct: "ENTRY APPEARS CORRECT", incorrect: "ENTRY APPEARS INCORRECT" }[r.verdict] || "PARTIALLY CORRECT";
  doc.setFillColor(r.verdict === "correct" ? 220 : 254, r.verdict === "correct" ? 252 : 226, r.verdict === "correct" ? 231 : 226);
  doc.rect(M, y - 12, W, 26, "F");
  doc.setFont("helvetica", "bold").setFontSize(11).setTextColor(r.verdict === "correct" ? 6 : 153, r.verdict === "correct" ? 78 : 27, r.verdict === "correct" ? 59 : 27);
  doc.text(verdictText, M + 8, y + 5);
  y += 32;

  heading("Entry submitted");
  body(r.input_summary || entryToText(r.lines));
  y += 4;
  body(`Total Debit ${money(r.total_debit)}   |   Total Credit ${money(r.total_credit)}`);
  if (r.narration) body(`Narration: ${r.narration}`);

  heading("Reviewer's note");
  body(r.explanation);

  if (r.rule_checks?.length) {
    heading("Rule engine checks");
    r.rule_checks.forEach((c) => body(`${c.passed ? "[PASS]" : "[FAIL]"} ${c.label} — ${c.detail}`));
  }
  if (r.corrected_entry?.length) {
    heading("Suggested entry");
    body(entryToText(r.corrected_entry));
  }
  [["Standard references", r.standard_refs], ["GST notes", r.gst_notes], ["Companies Act 2013", r.companies_act_notes]].forEach(
    ([t, items]) => {
      if (items?.length) {
        heading(t);
        items.forEach((i) => body(`•  ${i}`));
      }
    }
  );

  y += 20;
  page();
  doc.setFont("helvetica", "italic").setFontSize(8).setTextColor(140);
  doc.text("Generated by LedgerCheck. Educational review tool, not a substitute for professional judgement.", M, y);

  doc.save(`ledgercheck-${r.analysis_id || "entry"}.pdf`);
};
